import { useContext, useMemo } from "react";

import { FeatureCardContext } from "../../FeatureCard/components/FeatureCardHeader/FeatureCardContext";
import { getPagesContainer, getPagesContainerIndex } from "../../FeatureCard/utils/getPagesContainer";
import { useWidgetContext } from "./useWidgetContext";
import { useProjectInfo } from "../../../ducks/project/hooks";
import { ConfigContainer, WidgetType } from "../../FeatureCard/types";

export const useWidgetConfiguration = (type: WidgetType): ConfigContainer & { currentConfig: ConfigContainer } => {
  const [{ content }] = useProjectInfo();
  const { page } = useWidgetContext(type);
  const { layerInfo } = useContext(FeatureCardContext) || {};

  const config =
    type === WidgetType.Dashboard ? content?.dashboardConfiguration : layerInfo?.configuration.cardConfiguration;

  return useMemo(() => {
    const pageContainer = getPagesContainer(config?.children);
    let currentConfig: ConfigContainer = { ...(config || {}) };

    if (pageContainer) {
      currentConfig = JSON.parse(JSON.stringify({ ...pageContainer.children[page - 1], children: config.children }));

      currentConfig.filters = [
        ...(config.filters?.filter(({ name }) => !currentConfig.filters?.some(item => item.name === name)) || []),
        ...(currentConfig.filters || []),
      ];
      currentConfig.layers = [
        ...(config.layers?.filter(({ name }) => !currentConfig.layers?.some(item => item.name === name)) || []),
        ...(currentConfig.layers || []),
      ];
      currentConfig.dataSources = [
        ...(config.dataSources?.filter(({ name }) => !currentConfig.dataSources?.some(item => item.name === name)) ||
          []),
        ...(currentConfig.dataSources || []),
      ];
      currentConfig.children.splice(
        getPagesContainerIndex(currentConfig.children),
        1,
        pageContainer.children[page - 1],
      );
    }

    return {
      ...config,
      currentConfig,
    };
  }, [config, page]);
};
